import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export function NewsletterPanel() {
  const [list, setList] = useState<Array<{ email: string; status: string; source: string; created_at: string }>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.admin.newsletter().then((res) => {
      setList(res);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <section className="admin-card">
      <div className="admin-card-head">
        <div>
          <h2>Suscriptores newsletter</h2>
          <p className="muted">Quienes dieron su email en la home para recibir novedades.</p>
        </div>
        <button type="button" className="ghost-button compact" onClick={() => api.admin.exportNewsletter()}>Export CSV</button>
      </div>
      {loading ? (
        <p className="muted">Cargando...</p>
      ) : list.length === 0 ? (
        <div className="empty-state subtle">
          <p>Aún no hay suscriptores.</p>
        </div>
      ) : (
        <ul className="newsletter-list">
          {list.map((s) => (
            <li key={s.email}>
              <strong>{s.email}</strong>
              <small>{new Date(s.created_at).toLocaleDateString('es-CL')}</small>
              <span className={`integration-badge ${s.status === 'active' ? 'ok' : 'pending'}`}>{s.status}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
